const KEY = "buma:msg-sound";
export const chimeEnabled = () => localStorage.getItem(KEY) !== "off";
export const setChimeEnabled = (on) => localStorage.setItem(KEY, on ? "on" : "off");

let last = 0;
export const resetChimeThrottle = () => { last = 0; };
// Two-tone message chime synthesised with WebAudio (no asset); throttled so overlapping polls never stack sounds.
export function playChime() {
  if (!chimeEnabled() || Date.now() - last < 3000) return;
  last = Date.now();
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx(); const t0 = ctx.currentTime;
    [[880, 0], [1174.66, 0.14]].forEach(([f, dt]) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = "sine"; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t0 + dt); g.gain.exponentialRampToValueAtTime(0.22, t0 + dt + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t0 + dt + 0.4);
      o.connect(g).connect(ctx.destination); o.start(t0 + dt); o.stop(t0 + dt + 0.45);
    });
    setTimeout(() => ctx.close().catch(() => {}), 1200);
  } catch (_) { /* autoplay blocked until the first user interaction */ }
}

// The service worker tells open tabs when a push arrived so they chime even if the OS notification is quiet.
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (e) => { if (e.data && e.data.type === "PUSH") playChime(); });
}
